import PlatformFeatureEnum from '@constants/enums/platform/feature';

export const FeatureDependencies = Object.freeze({
    [PlatformFeatureEnum.ADVANCED_VISIBILITY_GROUPS]: [PlatformFeatureEnum.BASIC_VISIBILITY_GROUPS]
});

const uniqueFeatures = features => {
    if (Array.isArray(features)) {
        return [...new Set(features)];
    }

    if (features === null || features === undefined) {
        return [];
    }

    return [features];
};

const buildRequiredToDependentsMap = dependencies => {
    return Object.entries(dependencies).reduce((index, [dependentFeature, requiredFeatures]) => {
        for (const requiredFeature of requiredFeatures) {
            if (!index[`${requiredFeature}`]) {
                index[`${requiredFeature}`] = [];
            }
            index[`${requiredFeature}`].push(dependentFeature);
        }

        return index;
    }, {});
};

export const resolveFeatureDependencies = (
    nextFeatures,
    previousFeatures = [],
    dependencies = FeatureDependencies
) => {
    let resolvedFeatures = uniqueFeatures(nextFeatures);
    const previous = uniqueFeatures(previousFeatures);

    const requiredToDependentsMap = buildRequiredToDependentsMap(dependencies);
    const removedFeatures = previous.filter(feature => !resolvedFeatures.includes(feature));

    // If a required feature was explicitly removed, dependent features must be removed too.
    if (removedFeatures.length > 0) {
        const dependentFeaturesToRemove = new Set();
        for (const removedFeature of removedFeatures) {
            for (const dependentFeature of requiredToDependentsMap[`${removedFeature}`] || []) {
                if (resolvedFeatures.includes(dependentFeature)) {
                    dependentFeaturesToRemove.add(dependentFeature);
                }
            }
        }

        if (dependentFeaturesToRemove.size > 0) {
            resolvedFeatures = resolvedFeatures.filter(feature => !dependentFeaturesToRemove.has(feature));
        }
    }

    // Any selected feature must include its required features.
    let changed = true;
    while (changed) {
        changed = false;
        for (const selectedFeature of [...resolvedFeatures]) {
            const requiredFeatures = dependencies[`${selectedFeature}`] || [];
            for (const requiredFeature of requiredFeatures) {
                if (!resolvedFeatures.includes(requiredFeature)) {
                    resolvedFeatures.push(requiredFeature);
                    changed = true;
                }
            }
        }
    }

    return uniqueFeatures(resolvedFeatures);
};
